export default function debounceTime(time, callback) {
    let timeout;
    return function () {
        const self = this, args = arguments;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(function () {
            callback.apply(self, args);
        }, time);
    }
}
